"use strict";

define('model/letter.template',['./base'], function (BaseModel) {
  var LetterTemplate = BaseModel.extend({
    urlRoot: '/rs/api/letter',
    virtual: {
      'templateTypeDescription': BaseModel.createKeyPathVirtual('templateType.description')
    },
    childModels: {
      'templateType': 'TemplateType'
    },
    validation: {
      name: {
        required: true,
        maxLength: 50
      }
    },
    defaults: {
      content: '',
      active: false,
      name: ''
    }
  }, {
    all: function all() {
      return this.createCollection('/rs/api/letter');
    },
    allByTemplateTypeId: function allByTemplateTypeId(id) {
      return this.createCollection('/rs/api/letter/type/:templateTypeId').params({
        templateTypeId: id
      });
    }
  });
  return LetterTemplate;
});

